/* MACONDO – restyle, early pass: runs while the page is still loading, so the collection page
   is already in its final shape at the first paint (no jump of the text / filters). */
(function () {
  var desk = window.matchMedia('(min-width: 750px)');
  /* men / women collections: the gender filter makes no sense there (hidden by CSS from the first paint) */
  if (/^\/collections\/(men|women|mens-[^/]+|womens-[^/]+)\/?$/.test(location.pathname)) document.documentElement.classList.add('m-col-gendered');
  /* category collections (Men's shoes, Women's bags...): the main category is already chosen, only the sub categories stay */
  if (/^\/collections\/(mens|womens)-[^/]+\/?$/.test(location.pathname)) {
    document.documentElement.classList.add('m-col-cat');
    var st = document.createElement('style');
    st.textContent = 'html.m-col-cat accordion-custom[data-filter-param-name*="product_type"]{display:none!important}';
    document.head ? document.head.appendChild(st) : document.documentElement.appendChild(st);
  }

  /* type rules that must apply from the first paint */
  (function () {
    var st2 = document.createElement('style');
    st2.textContent =
      /* filter options: Title Case (Man, Clothing, Jean Paul Gaultier, Black, Boots) - headings stay uppercase */
      '#filters-drawer accordion-custom:not([data-filter-param-name*="option"]) .facets__inputs-list-item .checkbox__label .checkbox__label-text,.facets accordion-custom:not([data-filter-param-name*="option"]) .checkbox__label-text{text-transform:none!important}' +
      /* product grid + product page tabs: brand bold uppercase, product name in Title Case */
      'html body product-card .product-card__content .text-block p > strong,html body product-card .product-card__content rte-formatter strong,html body product-card .product-card__content .text-block p:has(> strong),.m-rel__brand{text-transform:uppercase!important;font-weight:700!important;letter-spacing:.02em!important}' +
      'main[data-template^="product"] h1{text-transform:none!important}' +
      /* sort menu: no box around it after a choice (iPhone kept the focus frame); no grey flash on taps (iPhone) */
      'html,html *{-webkit-tap-highlight-color:rgba(0,0,0,0)!important}' +
      /* filter headings always black (the theme dimmed the closed ones to grey) */
      '.facets__summary{opacity:1!important}.facets__summary .icon-caret{color:#000!important;transition:none!important}' +
      /* product cards: photos are a fraction of a pixel wide, so a sliver of the next / previous photo
         showed as a dark line on the sides when the photo changes on hover - cut 1px on each side */
      'product-card slideshow-slides{clip-path:inset(0 1px)}' +
      '.sorting-filter__select-wrapper:has(:focus-visible),.sorting-filter__select-wrapper:has(:focus){outline:none!important;box-shadow:none!important}.sorting-filter__select:focus,.sorting-filter__select:focus-visible{outline:none!important;box-shadow:none!important}' +
      /* phone product page: even spacing (brand / name / price / sizes / buy / tabs / related) */
      '@media screen and (max-width:749px){' +
      'main[data-template^="product"] .product-details .group-block-content>.group-block .layout-panel-flex{row-gap:0!important}' +
      'main[data-template^="product"] .product-details .custom-vendor-link{margin:0!important;line-height:1.15!important}' +
      'main[data-template^="product"] .product-details h1{margin-top:8px!important}' +
      'main[data-template^="product"] .product-details .text-block:has(>h1){padding-bottom:0!important}' +
      'main[data-template^="product"] .product-details product-price{padding-top:0!important;margin-top:12px!important}' +
      'main[data-template^="product"] .product-details product-price .price{font-size:16px!important;font-weight:400!important;letter-spacing:.03em!important;color:#000!important}' +
      'main[data-template^="product"] .product-details product-price .tax-note{margin-top:4px!important}' +
      'main[data-template^="product"] .product-details .group-block-content>.divider{margin-top:20px!important}' +
      'main[data-template^="product"] .product-details .group-block-content>.divider+.spacer-block{height:20px!important;min-height:20px!important}' +
      '.m-rel-host .m-rel{padding-top:18px!important}}';
    (document.head || document.documentElement).appendChild(st2);
  })();

  function keepUpper(w) { return /\./.test(w) || /^[A-Z0-9&]{1,3}$/.test(w) && (/\d|&/.test(w) || !/[AEIOUY]/.test(w)); }
  var SMALL = { de: 1, des: 1, du: 1, da: 1, di: 1, del: 1, della: 1, la: 1, le: 1, les: 1, x: 1, and: 1, et: 1, von: 1, van: 0 };
  var KEEP = { UGG: 1, MSGM: 1, JW: 1, DKNY: 1, ASICS: 0 };
  /* brands: every word with a capital letter (Jean Paul Gaultier, Comme des Garçons, CP Company, A.P.C.) */
  function brandCase(s) {
    var i = 0;
    return s.trim().split(/(\s+)/).map(function (w) {
      if (/^\s+$/.test(w) || !w) return w;
      var first = i++ === 0;
      var l = w.toLocaleLowerCase();
      if (!first && SMALL[l]) return l;
      if (keepUpper(w) || KEEP[w.toUpperCase()]) return KEEP[w.toUpperCase()] ? w.toUpperCase() : w;
      return l.replace(/(^|[-\/])(\S)/g, function (m, a, b) { return a + b.toLocaleUpperCase(); });
    }).join('');
  }
  function sentenceCase(s) {
    var first = true;
    return s.trim().split(/(\s+)/).map(function (w) {
      if (/^\s+$/.test(w) || !w) return w;
      if (keepUpper(w)) { first = false; return w; }
      var l = w.toLocaleLowerCase();
      if (first) { first = false; return l.charAt(0).toLocaleUpperCase() + l.slice(1); }
      return l;
    }).join('');
  }

  /* ---------- categories filter: only Clothing / Bags / Shoes / Accessories ---------- */
  var CATS = { CLOTHING: [1, 'Clothing'], BAG: [2, 'Bags'], BAGS: [2, 'Bags'], SHOES: [3, 'Shoes'], ACCESSORIES: [4, 'Accessories'] };
  function tidyCategories() {
    /* runs on every update: the filters are re-rendered (morphed) after each selection */
    document.querySelectorAll('accordion-custom[data-filter-param-name*="product_type"] .facets__inputs-list-item').forEach(function (li) {
      var t = li.querySelector('.checkbox__label-text');
      var input = li.querySelector('input');
      if (!t && !input) return;
      var key = ((input && input.getAttribute('data-label')) || (t ? t.textContent : li.textContent)).trim().toUpperCase();
      var hit = CATS[key] || CATS[(t ? t.textContent : '').trim().toUpperCase()];
      if (!hit) { if (!li.classList.contains('m-cat-hide')) li.classList.add('m-cat-hide'); return; }
      if (li.classList.contains('m-cat-hide')) li.classList.remove('m-cat-hide');
      if (li.style.order !== String(hit[0])) li.style.order = hit[0];
      if (t && t.textContent !== hit[1]) t.textContent = hit[1];
      if (t && !t.hasAttribute('data-m-sc')) t.setAttribute('data-m-sc', '1');
    });
    /* a category list with a single choice (e.g. Men's clothing -> only "Clothing") is hidden */
    document.querySelectorAll('accordion-custom[data-filter-param-name*="product_type"]').forEach(function (acc) {
      var n = acc.querySelectorAll('.facets__inputs-list-item:not(.m-cat-hide)').length;
      var one = n <= 1 && !acc.querySelector('input:checked');
      if (acc.classList.contains('m-cat-single') !== one) acc.classList.toggle('m-cat-single', one);
    });
  }

  /* ---------- desktop sidebar: names, open state and sentence case before the first paint ---------- */
  function tidySidebar() {
    if (!desk.matches) return;
    document.querySelectorAll('.facets--vertical:not(.facets--drawer) accordion-custom[data-filter-param-name]').forEach(function (acc) {
      var p = acc.getAttribute('data-filter-param-name');
      var lab = acc.querySelector('.facets__summary .facets__label');
      var d = acc.querySelector('details');
      var main = /product_type|vendor/.test(p);
      if (/product_type/.test(p)) { acc.classList.add('m-f-cat', 'm-f-open'); if (lab && lab.textContent !== 'Categories') lab.textContent = 'Categories'; }
      else if (/vendor/.test(p)) { acc.classList.add('m-f-brand', 'm-f-open'); if (lab && lab.textContent !== 'Designers') lab.textContent = 'Designers'; }
      if (d && !acc.hasAttribute('data-m-init') && document.readyState === 'loading') {
        acc.setAttribute('data-m-init', '1');
        if (!main) { acc.removeAttribute('open'); acc.removeAttribute('open-by-default-on-desktop'); }
        if (d.open !== main) d.open = main;
      }
    });
  }

  /* filter options everywhere (desktop list + phone drawer): every word with a capital letter.
     Categories have their own names, sizes stay as they are (XS, M/L, 42). */
  function tidyOptions() {
    document.querySelectorAll('accordion-custom[data-filter-param-name]').forEach(function (acc) {
      var p = acc.getAttribute('data-filter-param-name');
      if (/product_type|option|price/.test(p)) return;
      acc.querySelectorAll('.checkbox__label-text').forEach(function (s) {
        var want = brandCase(s.textContent);
        if (s.textContent !== want) s.textContent = want;
        if (!s.hasAttribute('data-m-sc')) s.setAttribute('data-m-sc', '1');
      });
    });
  }

  /* product page: product name in Title Case (the brand above stays uppercase) */
  function tidyPdpTitle() {
    var h = document.querySelector('main[data-template^="product"] h1');
    if (!h || h.children.length) return;
    var want = brandCase(h.textContent.replace(/\s+/g, ' '));
    if (h.textContent.trim() !== want) h.textContent = want;
  }

  /* ---------- collection text placed under the crumbs straight away ---------- */
  function earlyCollection() {
    if (!desk.matches) return;
    var main = document.querySelector('main[data-template^="collection"]');
    if (!main) return;
    var grid = main.querySelector('.main-collection-grid > div');
    if (!grid || grid.querySelector('.m-cdesc')) return;
    if (/[?&]filter\./.test(location.search)) return;
    var h4 = main.querySelector(':scope > .shopify-section[id$="__section"] .text-block.h4');
    if (!h4) return;
    var box = document.createElement('div');
    box.className = 'm-cdesc';
    box.innerHTML = h4.innerHTML;
    grid.insertBefore(box, grid.firstChild);
  }

  /* phone filter drawer: every section starts closed */
  function tidyDrawer() {
    if (document.readyState !== 'loading') return;
    document.querySelectorAll('#filters-drawer accordion-custom[data-filter-param-name]:not([data-m-init])').forEach(function (acc) {
      acc.setAttribute('data-m-init', '1');
      acc.removeAttribute('open-by-default-on-mobile');
      acc.removeAttribute('open-by-default-on-desktop');
      acc.removeAttribute('open');
      var d = acc.querySelector('details');
      if (d && d.open) d.open = false;
    });
  }

  /* product cards: brand names in title case (CP Company, Jean Paul Gaultier) */
  function tidyCards() {
    document.querySelectorAll('product-card .text-block strong[data-m-tc]').forEach(function (b) {
      var want = brandCase(b.textContent);
      if (b.textContent !== want) b.textContent = want;
    });
  }

  /* brand list page: the rich text has stray line breaks / empty links (uneven gaps).
     Rebuild each column as clean letter groups, moving the original nodes (ids kept). */
  function tidyBrandList() {
    var sec = document.querySelector('main[data-template="page.brand"] .tabs-group-section');
    if (!sec) return;
    var wrap = sec.closest('.shopify-section');
    if (document.readyState === 'loading' && !(wrap && wrap.nextElementSibling)) return;
    sec.querySelectorAll('.tab-columns:not([data-m-bl])').forEach(function (col) {
      col.setAttribute('data-m-bl', '1');
      var nodes = col.querySelectorAll('strong, a');
      var frag = document.createDocumentFragment();
      var group = null;
      Array.prototype.forEach.call(nodes, function (n) {
        if (n.tagName === 'STRONG') {
          if (n.closest('a')) return;
          if (!n.textContent.trim()) return;
          group = document.createElement('div');
          group.className = 'm-bl-group';
          n.textContent = n.textContent.trim();
          group.appendChild(n);
          frag.appendChild(group);
        } else {
          var name = n.textContent.replace(/\s+/g, ' ').trim();
          if (!name) return;
          n.textContent = name;
          if (!group) { group = document.createElement('div'); group.className = 'm-bl-group'; frag.appendChild(group); }
          group.appendChild(n);
        }
      });
      col.innerHTML = '';
      col.appendChild(frag);
      col.classList.add('m-bl');
    });
  }

  /* product page tabs (More from / Similar / ...): second photo on hover (desktop) or swipe (phone) */
  var prodCache = {};
  function img600(u) {
    if (!u) return '';
    if (/^\/\//.test(u)) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=600';
  }
  function tidyRelated() {
    document.querySelectorAll('.m-rel__card > a:not([data-m2])').forEach(function (a) {
      a.setAttribute('data-m2', '1');
      var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      var box = a.querySelector('.m-rel__img');
      if (!m || !box) return;
      var h = m[1];
      if (!prodCache[h]) prodCache[h] = fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; });
      prodCache[h].then(function (p) {
        var src = p && p.images && p.images[1];
        if (!src || box.querySelector('.m-rel__img2')) return;
        var im = document.createElement('img');
        im.className = 'm-rel__img2';
        im.alt = '';
        im.loading = 'lazy';
        im.src = img600(typeof src === 'string' ? src : src.src);
        box.appendChild(im);
        box.classList.add('has-2');
      });
    });
  }

  /* product page, "Similar products": same category + same gender (or unisex), other brands, newest first */
  function money(c) {
    var n = (c / 100).toFixed(2).split('.');
    return '€' + n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + n[1];
  }
  function relCard(p) {
    var t = p.title || '';
    if (p.vendor && t.toUpperCase().indexOf(p.vendor.toUpperCase() + ' ') === 0) t = t.slice(p.vendor.length + 1);
    var cmp = p.compare_at_price || 0, price = p.price || 0;
    var off = cmp > price ? '<s>' + money(cmp) + '</s> <span class="m-off">(-' + Math.round((1 - price / cmp) * 100) + '%)</span> ' : '';
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var esc = function (x) { return String(x).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); };
    return '<li class="m-rel__card"><a href="/products/' + p.handle + '">' +
      '<span class="m-rel__img">' + (img ? '<img src="' + esc(img600(img)) + '" alt="" loading="lazy">' : '') + '</span>' +
      '<span class="m-rel__brand">' + esc(brandCase(p.vendor || '')) + '</span>' +
      '<span class="m-rel__title">' + esc(t) + '</span>' +
      '<span class="m-rel__price">' + off + money(price) + '</span></a></li>';
  }
  var simStarted = false;
  function jget(u) { return fetch(u).then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; }); }
  function prod(h) { prodCache[h] = prodCache[h] || jget('/products/' + h + '.js'); return prodCache[h]; }
  function handlesFrom(url) {
    return fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      var doc = new DOMParser().parseFromString(html || '', 'text/html');
      var hs = [];
      doc.querySelectorAll('product-card a[href*="/products/"], .product-grid a[href*="/products/"]').forEach(function (a) {
        var h = (a.getAttribute('href').match(/\/products\/([^/?#]+)/) || [])[1];
        if (h && hs.indexOf(h) === -1) hs.push(h);
      });
      return hs;
    }).catch(function () { return []; });
  }
  function tagOf(p, k) { var x = (p.tags || []).filter(function (t) { return t.indexOf(k + '=') === 0; })[0]; return x ? x.slice(k.length + 1).trim().toUpperCase() : ''; }
  /* put cards in a tab (replace or append); create the tab when the theme did not build it */
  function fillTab(box, re, label, cards, append, afterRe) {
    var btns = Array.prototype.slice.call(box.querySelectorAll('.m-rel__nav button'));
    var uls = Array.prototype.slice.call(box.querySelectorAll('.m-rel__panels > .m-rel__grid'));
    var i = -1;
    btns.forEach(function (b, k) { if (re.test(b.textContent.trim())) i = k; });
    var html = cards.map(relCard).join('');
    if (i > -1 && uls[i]) { if (append) uls[i].insertAdjacentHTML('beforeend', html); else uls[i].innerHTML = html; return; }
    if (!cards.length || !btns.length) return;
    var at = 0;
    btns.forEach(function (b, k) { if (afterRe && afterRe.test(b.textContent.trim())) at = k; });
    var b = document.createElement('button');
    b.type = 'button'; b.setAttribute('role', 'tab'); b.setAttribute('aria-selected', 'false');
    b.textContent = label;
    var ul = document.createElement('ul');
    ul.className = 'm-rel__grid'; ul.hidden = true; ul.innerHTML = html;
    btns[at].after(b); uls[at].after(ul);
    b.addEventListener('click', function () {
      box.querySelectorAll('.m-rel__nav button').forEach(function (x) { x.classList.toggle('is-active', x === b); x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
      box.querySelectorAll('.m-rel__panels > .m-rel__grid').forEach(function (x) { x.hidden = x !== ul; });
    });
    btns.forEach(function (x) { x.addEventListener('click', function () { ul.hidden = true; b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false'); }); });
  }
  function shownHandles(box) {
    return Array.prototype.map.call(box.querySelectorAll('.m-rel__card > a'), function (a) { return ((a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/) || [])[1]; });
  }
  function initSimilar() {
    if (simStarted) return;
    var box = document.querySelector('.m-rel');
    if (!box || !box.querySelector('.m-rel__nav button')) return;
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    simStarted = true;
    prod(m[1]).then(function (me) {
      if (!me || !me.id) return;
      var type = me.type || tagOf(me, 'Categoria');
      var sex = tagOf(me, 'Sesso');
      var sexOk = function (p) { var s2 = tagOf(p, 'Sesso'); return !sex || sex === 'UNISEX' || !s2 || s2 === sex || s2 === 'UNISEX'; };
      var base = function (sort, withType) {
        var u = new URL('/collections/all', location.origin);
        if (withType && type) u.searchParams.append('filter.p.product_type', type);
        if (sex && sex !== 'UNISEX') { u.searchParams.append('filter.p.m.custom.gender', sex); u.searchParams.append('filter.p.m.custom.gender', 'UNISEX'); }
        u.searchParams.set('sort_by', sort);
        return u.pathname + u.search;
      };
      var same = function (a, b) { return (a || '').toUpperCase() === (b || '').toUpperCase(); };
      /* 1. Similar products: same category + gender, other brands, newest first */
      var step1 = !type ? Promise.resolve() : handlesFrom(base('created-descending', true)).then(function (hs) {
        return Promise.all(hs.filter(function (h) { return h !== me.handle; }).slice(0, 16).map(prod));
      }).then(function (list) {
        list = (list || []).filter(function (p) { return p && p.handle && p.available !== false && !same(p.vendor, me.vendor) && sexOk(p); }).slice(0, 5);
        if (list.length) fillTab(box, /^similar/i, 'Similar products', list, false, /^more from/i);
      });
      /* 2. You might also like: always 5 — completed with other categories (same gender), best sellers first */
      step1.then(function () {
        var btns = Array.prototype.slice.call(box.querySelectorAll('.m-rel__nav button'));
        var uls = Array.prototype.slice.call(box.querySelectorAll('.m-rel__panels > .m-rel__grid'));
        var i = -1;
        btns.forEach(function (b, k) { if (/^you might/i.test(b.textContent.trim())) i = k; });
        var have = i > -1 && uls[i] ? uls[i].querySelectorAll('.m-rel__card').length : 0;
        if (have >= 5) return;
        var shown = shownHandles(box);
        return handlesFrom(base('best-selling', false)).then(function (hs) {
          return Promise.all(hs.filter(function (h) { return h !== me.handle && shown.indexOf(h) === -1; }).slice(0, 24).map(prod));
        }).then(function (list) {
          list = (list || []).filter(function (p) { return p && p.handle && p.available !== false && !same(p.type, type) && sexOk(p); }).slice(0, 5 - have);
          if (list.length) fillTab(box, /^you might/i, 'You might also like', list, true, /^similar|^more from/i);
        });
      });
    });
  }

  /* after every filter update the ticks must match the address (what is really applied):
     the theme sometimes kept an old tick, which came back with the next selection */
  var lastQ = null, syncUntil = 0;
  function syncTicks() {
    if (Date.now() > syncUntil) return;
    var p = new URLSearchParams(location.search);
    document.querySelectorAll('.facets input[type="checkbox"][name^="filter."], #filters-drawer input[type="checkbox"][name^="filter."]').forEach(function (i) {
      var want = p.getAll(i.name).indexOf(i.value) > -1;
      if (i.checked !== want) i.checked = want;
    });
  }
  function watchUrl() {
    if (location.search === lastQ) return;
    lastQ = location.search;
    syncUntil = Date.now() + 4000;
    [0, 300, 1000, 2000, 3800].forEach(function (ms) { setTimeout(function () { try { syncTicks(); } catch (e) {} }, ms); });
  }

  /* categories: one at a time (picking Clothing after Bags switches, no need to untick Bags) */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.name === 'sort_by' && t.blur) setTimeout(function () { t.blur(); }, 0);
    if (t && t.name && t.name.indexOf('filter.') === 0) syncUntil = 0;
    if (!t || t.name !== 'filter.p.product_type' || !t.checked) return;
    var form = t.form || t.closest('form') || document;
    form.querySelectorAll('input[name="filter.p.product_type"]:checked').forEach(function (o) { if (o !== t) o.checked = false; });
  }, true);

  /* phone search: opened from the middle / bottom of a page, iPhone left the view scrolled down
     (white screen, search bar out of sight). Go to the top instantly before it opens,
     and back to the same point when it closes. */
  var mob = window.matchMedia('(max-width: 749px)');
  var searchY = null;
  function jumpTo(y) {
    var h = document.documentElement, prev = h.style.scrollBehavior;
    h.style.scrollBehavior = 'auto';
    window.scrollTo(0, y);
    h.style.scrollBehavior = prev;
  }
  document.addEventListener('click', function (e) {
    if (!mob.matches) return;
    var b = e.target.closest && e.target.closest('[on\\:click*="search-modal/showDialog"]');
    if (!b) return;
    searchY = window.scrollY;
    if (searchY > 0) jumpTo(0);
  }, true);
  document.addEventListener('close', function (e) {
    if (searchY === null || !e.target.closest || !e.target.closest('#search-modal')) return;
    var y = searchY, n = 0;
    searchY = null;
    (function back() {
      if (document.body.style.position === 'fixed' && n++ < 20) return setTimeout(back, 30);
      jumpTo(y);
    })();
  }, true);

  /* desktop sidebar: open / close the filter sections ourselves (no animation, one click) */
  document.addEventListener('click', function (e) {
    if (!desk.matches) return;
    var s = e.target.closest && e.target.closest('.facets--vertical:not(.facets--drawer) details.facets__panel > summary');
    if (!s) return;
    var d = s.parentElement;
    e.preventDefault();
    e.stopPropagation();
    var acc = d.closest('accordion-custom');
    if (acc && acc.classList.contains('m-f-open')) return;
    setTimeout(function () { d.open = !d.open; }, 0);
  }, true);

  function run() {
    try { tidyDrawer(); } catch (e) {}
    try { earlyCollection(); } catch (e) {}
    try { tidySidebar(); } catch (e) {}
    try { tidyCategories(); } catch (e) {}
    try { tidyOptions(); } catch (e) {}
    try { tidyPdpTitle(); } catch (e) {}
    try { tidyBrandList(); } catch (e) {}
    try { initSimilar(); } catch (e) {}
    try { tidyRelated(); } catch (e) {}
    try { watchUrl(); syncTicks(); } catch (e) {}
  }
  /* run on every DOM change while parsing (before paint), then keep running for filter updates */
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
